var _a, _b;
// All languages
var AR_CODE = 'ar';
var DE_CODE = 'de';
var EN_CODE = 'en';
var EN_US_CODE = 'en-US';
var ES_CODE = 'es';
var FR_CODE = 'fr';
var ID_CODE = 'id';
var IT_CODE = 'it';
var JA_CODE = 'ja';
var KO_CODE = 'ko';
var NL_CODE = 'nl';
var PL_CODE = 'pl';
var PT_CODE = 'pt';
var RU_CODE = 'ru';
var TR_CODE = 'tr';
var VI_CODE = 'vi';
var ZH_CODE = 'zh';
/**
 * All interface languages
 * @type {Array<InterfaceLangsTypes>}
 */
var ALL_INTERFACE_LANGS_CODES = [
    AR_CODE,
    DE_CODE,
    EN_CODE,
    EN_US_CODE,
    ES_CODE,
    FR_CODE,
    ID_CODE,
    IT_CODE,
    JA_CODE,
    KO_CODE,
    PL_CODE,
    PT_CODE,
    RU_CODE,
    TR_CODE,
    VI_CODE,
    ZH_CODE,
];
/**
 * All course languages
 * @type {Array<CourseLangsTypes>}
 */
var ALL_COURSE_LANGS_CODES = [
    EN_CODE,
    ES_CODE,
    FR_CODE,
    DE_CODE,
    JA_CODE,
    IT_CODE,
    NL_CODE,
    RU_CODE,
    ZH_CODE,
    AR_CODE,
    TR_CODE,
    PT_CODE,
    PL_CODE,
    KO_CODE,
];
/**
 * Interface languages displayed in respective language translations
 * @type {Object<RespectiveInterfaceLangCodes>}
 */
var ALL_INTERFACE_LANGS_RESPECTIVE = (_a = {},
    _a[AR_CODE] = 'اللغة العربية',
    _a[ZH_CODE] = '中文',
    _a[EN_CODE] = 'English (UK)',
    _a[EN_US_CODE] = 'English (US)',
    _a[FR_CODE] = 'Français',
    _a[DE_CODE] = 'Deutsch',
    _a[IT_CODE] = 'Italiano',
    _a[JA_CODE] = '日本語',
    _a[PL_CODE] = 'Polski',
    _a[PT_CODE] = 'Português',
    _a[RU_CODE] = 'Pусский',
    _a[ES_CODE] = 'Español',
    _a[TR_CODE] = 'Türkçe',
    _a[ID_CODE] = 'Bahasa Indonesia',
    _a[KO_CODE] = '한국어',
    _a[VI_CODE] = 'Tiếng Việt',
    _a);
/**
 * Up-to-date list of languages with certificates needed to display relevant information
 * i.e. when viewing another user's profile - certificate badges will not be shown if the language does not support these
 * @type {Array<CertificateLangsTypes>}
 */
var LANGUAGES_CONTAINING_CERTIFICATES = [
    DE_CODE,
    EN_CODE,
    ES_CODE,
    FR_CODE,
    IT_CODE,
    PT_CODE,
];
/**
 * Languages that support special characters
 * @type {Array<SpecialCharactersLangsTypes>}
 */
var LANGUAGES_SUPPORTING_SPECIAL_CHARACTERS = [
    ES_CODE,
    FR_CODE,
    DE_CODE,
    IT_CODE,
    PT_CODE,
    PL_CODE,
    TR_CODE,
    AR_CODE,
    RU_CODE,
    NL_CODE,
];
/**
 * Languages that display in RTL direction
 * @type {Array<RTLLangsTypes>}
 */
var LANGUAGES_RTL_CODES = [AR_CODE];
/**
 * IETF BCP-47 Language codes
 * Used to identify human languages
 * https://en.wikipedia.org/wiki/IETF_language_tag
 * @type {Object<BCP47LangCodes>}
 */
var BCP47_LANG_CODES = (_b = {},
    _b[AR_CODE] = 'ar-SA',
    _b[DE_CODE] = 'de-DE',
    _b[EN_CODE] = 'en-GB',
    _b[EN_US_CODE] = 'en-US',
    _b[ES_CODE] = 'es-ES',
    _b[FR_CODE] = 'fr-FR',
    _b[ID_CODE] = 'id-ID',
    _b[IT_CODE] = 'it-IT',
    _b[JA_CODE] = 'ja-JP',
    _b[KO_CODE] = 'ko-KR',
    _b[NL_CODE] = 'nl-NL',
    _b[PL_CODE] = 'pl-PL',
    _b[PT_CODE] = 'pt-PT',
    _b[RU_CODE] = 'ru-RU',
    _b[TR_CODE] = 'tr-TR',
    _b[VI_CODE] = 'vi-VN',
    _b[ZH_CODE] = 'zh-CN',
    _b);

export { ALL_COURSE_LANGS_CODES, ALL_INTERFACE_LANGS_CODES, ALL_INTERFACE_LANGS_RESPECTIVE, AR_CODE, BCP47_LANG_CODES, DE_CODE, EN_CODE, EN_US_CODE, ES_CODE, FR_CODE, ID_CODE, IT_CODE, JA_CODE, KO_CODE, LANGUAGES_CONTAINING_CERTIFICATES, LANGUAGES_RTL_CODES, LANGUAGES_SUPPORTING_SPECIAL_CHARACTERS, NL_CODE, PL_CODE, PT_CODE, RU_CODE, TR_CODE, VI_CODE, ZH_CODE };
//# sourceMappingURL=index.esm.js.map
